/* eslint-disable react-hooks/exhaustive-deps */
import '@/styles/studio.scss';
import React, { useEffect, useState, useContext, useRef } from 'react';
import { getUser, checkLogin } from '@/utils';
import { page as getStudiosList } from '@/services/saas/studio';
import { TabBar, NavBar, ListView, PullToRefresh } from 'antd-mobile';
import { MyStudioItem, OtherStudioItem } from '@/components/studio/studioItem';
import sysConfig from '@/sysConfig';
import Filter from '@/components/filter';
import { MyContext } from '@/utils/contextManager';
import DrawerWrapper from '@/components/drawerWrapper';
import SearchPage from '@/components/search';
import { dropDown as queryDictBiz } from '@/services/saas/dictbiz';
import { useHistory } from 'react-router';

const { preRouteUrl } = sysConfig;

function StudioList(props) {
  const [attrData, setAttrData] = useState([]);
  const [selectedTab, setSelectedTab] = useState('1');
  const [myStuidos, setMyStuidos] = useState(false);
  const pageSize = 5;
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  let [pageIndex, setIndex] = useState(0);
  const [draging, setDraging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myLoading, setMyLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const listRef = useRef();

  const dataRef = useRef();

  const history = useHistory();

  const menus = [
    { key: '1', id: 'famousStudio', title: '名师工作室' },
    { key: '2', id: 'studiesCommunity', title: '研修共同体' },
  ];

  const { setDrawer = () => {} } = useContext(MyContext);
  const switchDrawer = () => {
    setDrawer();
  };
  const { setFilters } = useContext(MyContext);

  const { userId } = getUser() || {};
  const keyValueRef = useRef({});
  const filterRef = useRef({});

  const getMyStudios = async () => {
    if (!isLogin) return;
    setMyLoading(true);
    setMyStuidos([]);
    const respMyStudios = await getStudiosList({
      includeMemberIds: userId,
      studioType: selectedTab,
      size: '-1',
    });
    if (respMyStudios.success && respMyStudios.data) {
      setMyStuidos(
        respMyStudios.data.records.map((item) => ({
          studioId: item.studioId,
          avatar: item.avatar,
          studioName: item.studioName,
          areaName: item.areaName,
          deptName: item.deptName,
          periodName: item.periodName,
          subjectName: item.subjectName,
          memberCount: item.memberCount,
          resCount: item.resCount,
          status: item.liveChannelLiveStatus,
        })),
      );
      setMyLoading(false);
    }
  };

  const getOtherStudios = async (page) => {
    if (!isLogin) return;
    setLoading(true);
    if (!page) {
      page = 1;
    }
    if (page === 1) {
      setData([]);
      setDataSouce(dataSource.cloneWithRows([]));
    }
    const param = {
      current: page,
      size: pageSize,
      studioName: keyValueRef.current.value,
      period: filterRef.current.period,
      subject: filterRef.current.subject,
      exceptMemberIds: userId,
      studioType: selectedTab,
    };
    const respOtherStudios = await getStudiosList(param);
    if (respOtherStudios.success) {
      const otherStuidos = (page === 1 ? [] : data).concat(
        respOtherStudios.data.records.map((item) => ({
          studioId: item.studioId,
          avatar: item.avatar,
          studioName: item.studioName,
          areaName: item.areaName,
          deptName: item.deptName,
          periodName: item.periodName,
          subjectName: item.subjectName,
          memberCount: item.memberCount,
          resCount: item.resCount,
          status: item.liveChannelLiveStatus,
        })),
      );
      setDraging(false);
      setLoading(false);
      setData(otherStuidos);
      setDataSouce(dataSource.cloneWithRows(otherStuidos));
      setHasMore(respOtherStudios.data.current < respOtherStudios.data.pages);
      setIndex(page);
    }
  };

  const getAttrData = async () => {
    if (!isLogin) return;
    const periodResp = await queryDictBiz({ code: 'period' });
    const subjectResp = await queryDictBiz({ code: 'subject' });
    if (periodResp.success && subjectResp.success) {
      setAttrData({
        period: {
          child: '',
          label: '学段',
          list: periodResp.data.map((item) => ({
            value: item.value,
            name: item.text,
          })),
        },
        subject: {
          child: '',
          label: '学科',
          list: subjectResp.data.map((item) => ({
            value: item.value,
            name: item.text,
          })),
        },
      });
    }
  };

  useEffect(() => {
    checkLogin({
      onLogin: () => {
        setIsLogin(true);
      },
      onCancel: () => {
        history.goBack();
      },
    });
  }, []);

  useEffect(() => {
    getMyStudios();
  }, [isLogin, selectedTab]);

  useEffect(() => {
    getOtherStudios(1);
  }, [isLogin, selectedTab, keyValueRef.current.value, filterRef.current.value]);

  useEffect(() => {
    getAttrData();
  }, [isLogin]);

  const handleClick = (code) => {
    if (code === 'search') {
      setFilters(
        <SearchPage
          value={keyValueRef.current.value}
          handleSearch={(item, handleClear) => {
            keyValueRef.current.value = item;
            keyValueRef.current.clearKeyValue = handleClear;
          }}
        ></SearchPage>,
      );
    }
    if (code === 'screen') {
      setFilters(
        <Filter
          value={filterRef.current.value}
          enableTime={false}
          data={attrData}
          handleSearch={(item, handleClear) => {
            filterRef.current.period = item.period ? item.period[0] : '';
            filterRef.current.subject = item.subject ? item.subject[0] : '';
            filterRef.current.value = item;
            filterRef.current.clearScreen = handleClear;
          }}
        ></Filter>,
      );
    }
  };

  const row = (rowData, sectionID, rowID) => {
    const {
      studioId,
      status,
      avatar,
      studioName,
      areaName,
      deptName,
      periodName,
      subjectName,
      memberCount,
      resCount,
    } = rowData;
    return (
      <div className="studioRes-list-item" key={rowID}>
        <OtherStudioItem
          status={status}
          avatar={avatar}
          name={studioName}
          subTitle={[areaName, deptName].join('.')}
          tag={[
            { title: '科目', value: [periodName, subjectName].join('') },
            { title: '成员', value: `${memberCount || 0}` },
            { title: '资源', value: `${resCount || 0}` },
          ]}
          link={`${preRouteUrl}/studioDetail/${studioId}`}
        />
      </div>
    );
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getOtherStudios(++pageIndex);
    }
  };

  return (
    <DrawerWrapper>
      <div className="studioTab">
        <div className="content" ref={listRef}>
          <ListView
            ref={dataRef}
            dataSource={dataSource}
            renderHeader={false}
            renderFooter={() => (
              <div style={{ padding: 10, textAlign: 'center' }}>
                {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
              </div>
            )}
            renderBodyComponent={() => (
              <ListWrap
                selectedTab={selectedTab}
                myStuidos={myStuidos}
                myLoading={myLoading}
                handleClick={(code) => handleClick(code)}
                switchDrawer={() => switchDrawer()}
              />
            )}
            renderRow={row}
            className="studioRes-list-wrap"
            pageSize={6}
            onScroll={() => {
              console.log('scroll');
            }}
            scrollRenderAheadDistance={500}
            onEndReached={onEndReached}
            onEndReachedThreshold={10}
            pullToRefresh={
              <PullToRefresh
                refreshing={draging}
                onRefresh={() => {
                  setDraging(true);
                  getOtherStudios(1);
                }}
              />
            }
          />
        </div>
        <TabBar
          unselectedTintColor="#999999"
          tintColor="#333333"
          barTintColor="#FFFFFF"
          tabBarPosition="bottom"
        >
          {menus.map((item) => (
            <TabBar.Item
              key={item.key}
              title={item.title}
              icon={<em className={`studio-icon ${item.id}`} />}
              selectedIcon={<em className={`studio-icon ${item.id} selected`} />}
              selected={selectedTab === item.key}
              onPress={() => {
                if (keyValueRef.current.value) {
                  keyValueRef.current.clearKeyValue();
                }
                setSelectedTab(item.key);
                listRef.current.scrollTop = 0;
                if (filterRef.current.clearScreen) {
                  filterRef.current.clearScreen();
                }
              }}
            />
          ))}
        </TabBar>
      </div>
    </DrawerWrapper>
  );
}

function ListWrap(props) {
  const { selectedTab, myStuidos, myLoading, handleClick, switchDrawer } = props;
  return (
    <div>
      <div className="myStudios">
        <div className="title">我的{selectedTab === '1' ? '名师工作室' : '研修共同体'}</div>
        <div className="list">
          {myLoading ? (
            <div
              className="footer"
              style={{
                display: myLoading ? 'block' : 'none',
              }}
            >
              加载中...
            </div>
          ) : myStuidos.length > 0 ? (
            myStuidos.map((item) => (
              <div className="item" key={item.studioId}>
                <MyStudioItem
                  status={item.status}
                  avatar={item.avatar}
                  name={item.studioName}
                  subTitle={[item.areaName, item.deptName].join('.')}
                  tag={[
                    { title: '科目', value: [item.periodName, item.subjectName].join('') },
                    { title: '成员', value: `${item.memberCount || 0}` },
                    { title: '资源', value: `${item.resCount || 0}` },
                  ]}
                  link={`${preRouteUrl}/studioDetail/${item.studioId}`}
                />
              </div>
            ))
          ) : (
            <div
              className="footer"
              style={{
                display: !myLoading ? 'block' : 'none',
              }}
            >
              没有更多
            </div>
          )}
        </div>
      </div>
      <div className="otherStuidos">
        <NavBar
          className="title"
          mode="dark"
          rightContent={[
            <div
              key="search"
              className="search"
              style={{ marginRight: '7.87vw' }}
              onClick={() => {
                handleClick('search');
                switchDrawer();
              }}
            ></div>,
            <div
              key="screen"
              className="screen"
              onClick={() => {
                handleClick('screen');
                switchDrawer();
              }}
            ></div>,
          ]}
        >
          其他{selectedTab === '1' ? '名师工作室' : '研修共同体'}
        </NavBar>
        <div className="otherStudio-list">{props.children}</div>
      </div>
    </div>
  );
}

export default StudioList;
